import '@assets/styles/index.scss'
import { useEffect } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { CustomToastingContainer } from '@components/toasting/Toast'
import { DrawerProvider } from '@core/context/DrawerContext'
import { UIModule } from '@core/modules/ui-settings/ui-settings.module'
import NiceModal from '@ebay/nice-modal-react'
import { CustomRouter } from './router'
import { TThemeInterface, createThemeInstance, CustomThemeProvider } from './core/theme'
import { envVars } from '@core/environment/env-vars'
import { queryClient } from '@core/query-client'

const App = () => {
    const theme = createThemeInstance(
        UIModule.getTheme() as TThemeInterface
    ) as Partial<TThemeInterface>
    const uiTheme = UIModule.getThemeName()

    const isDev = envVars.REACT_APP_ENV === 'development'

    const changeAppearanceHandler = () => {
        const t = uiTheme === 'dark' ? 'light' : 'dark'
        UIModule.setTheme(t, true)
    }

    const handleKeyDown = (event: any) => {
        if (event.metaKey && event.key === 'd') {
            changeAppearanceHandler()
        }
    }

    useEffect(() => {
        if (isDev) {
            window.addEventListener('keydown', handleKeyDown)
            return () => {
                window.removeEventListener('keydown', handleKeyDown)
            }
        }
    }, [uiTheme])

    return (
        <QueryClientProvider client={queryClient}>
            <CustomThemeProvider customTheme={theme}>
                <DrawerProvider>
                    <NiceModal.Provider>
                        <CustomToastingContainer />
                        <CustomRouter />
                    </NiceModal.Provider>
                </DrawerProvider>
            </CustomThemeProvider>
            {isDev && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    )
}

export default App
